import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import CookieConsent from "@/components/CookieConsent";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Install from "./pages/Install";
import Admin from "./pages/Admin";
import ValidateTicket from "./pages/ValidateTicket";
import InvitePage from "./pages/InvitePage";
import Dashboard from "./pages/Dashboard";
import PixPayment from "./pages/PixPayment";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]"><div className="text-xl text-[#115E59]">Carregando...</div></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/instalar" element={<Install />} />
      <Route path="/validate/:ticketCode" element={<ValidateTicket />} />
      <Route path="/convite/:inviteCode" element={<InvitePage />} />
      <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/pix-payment" element={<ProtectedRoute><PixPayment /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <CookieConsent />
      </div>
    </ErrorBoundary>
  );
}

export default App;
